import { Route, Routes } from 'react-router-dom';
import ChatArea from './ChatArea';
import ChatMessenger from './ChatMessenger';
import { useWallet } from './context/WalletContext';
import Bridge from './Bridge';
import Layout from './layouts/main';

export const App = () => {
  const { account } = useWallet();
  return (
    <>
      <Routes>
        <Route path="/" element={<Bridge />} />
        <Route path="/chats" element={account ? <ChatMessenger /> : <Layout children />} />
        <Route path="/chat-area/:roomId" element={account ? <ChatArea /> : <Layout children />} />
        <Route path="*" element={<h1>404: Page Not Found</h1>} />
      </Routes>
    </>
  );
};
